export const selectAiProducts = (state) => state.aiProducts.products;

export const selectAiProduct = (state) => state.aiProducts.product;
